<template>
  <div class="flex-1 flex flex-col justify-between">
    <transition
      mode="out-in"
      enter-active-class="transform ease-out duration-300 transition"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div v-if="!is_add_new_field_metric_shown">
        <div>
          <MultiSelectInputFlat
            :items="current_metrics"
            :required-items="required_items"
            :value="selected_metrics"
            name="table_metrics"
            :is-draggable="true"
            label-attr="name"
            value-attr="id"
            :allow-null="false"
            :is-flat="true"
            :return-objects="true"
            :label="$t('Metrics list')"
            classes="w-full"
            input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light "
            :selection-text="null"
            :show-label="false"
            @update:currentItems="
              ($event) => {
                handleSelectMetrics($event)
              }
            " />

          <div
            class="flex py-5 mb-3 w-full text-blue font-normal cursor-pointer items-center content-center"
            @click="
              () => {
                is_add_new_field_metric_shown = true
                $emitter.emit('changeModalCompanyTitle', 'Add new field')
              }
            ">
            <Plus class="w-5 h-5 ml-1" />
            <div class="pl-1">
              {{ $t("Add new field") }}
            </div>
          </div>
        </div>
        <div class="flex gap-2 pt-2 w-full flex-row justify-between">
          <button type="button" class="cancel-btn w-1/2 m-0 dark:border-dark-divider-border" @click="$emit('cancel')">
            {{ $t("Cancel") }}
          </button>
          <button class="primary-btn w-1/2" @click="saveCheckedMetrics()">{{ $t("Save") }}</button>
        </div>
      </div>
      <NewMetricForm
        v-else
        :object-type="objectType"
        @cancel="is_add_new_field_metric_shown = false"
        @done="is_add_new_field_metric_shown = false" />
    </transition>
  </div>
</template>

<script>
import NewMetricForm from "@/components/forms/NewMetricForm.vue"
import { Plus } from "lucide-vue-next"
import MultiSelectInputFlat from "@/components/shared/MultiSelectInputFlat.vue"

export default {
  components: {
    NewMetricForm,
    Plus,
    MultiSelectInputFlat
  },
  inject: ["getViewMetrics", "setViewMetrics"],
  props: {
    insideModal: null,
    /* In the Case of */
    includedMetrics: {
      type: Array,
      required: false
    },
    objectType: {
      type: String,
      required: true
    },
    pageReference: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    },
    componentReference: {
      type: String,
      required: false
    }
  },

  emits: ["cancel", "submitted", "update:includedMetrics", "done"],
  data() {
    return {
      required_items: [],
      selected_metrics: null,
      current_metrics: [],
      is_all_checkbox_checked: false,
      is_add_new_field_metric_shown: false
    }
  },
  watch: {
    is_all_checkbox_checked() {
      this.current_metrics = this.current_metrics.map((metric) => {
        metric.is_checked = this.is_all_checkbox_checked
        return metric
      })
    },
    includedMetrics: {
      deep: true,
      handler() {
        this.initMetrics()
      }
    }
  },
  created() {
    this.initMetrics()
  },
  methods: {
    handleSelectMetrics(e) {
      this.selected_metrics = e
    },
    initMetrics() {
      this.required_items = Object.values(this.$store.state.integration.metrics_mapping).map((v) => v)
      this.current_metrics = this.$store.state.metrics.filter((t) => t.object_type == this.objectType)

      this.selected_metrics = this.includedMetrics
      let full_required_items = this.current_metrics.filter((m) => this.required_items.includes(m.reference_name))
      this.selected_metrics = this.selected_metrics.concat(
        full_required_items.filter((m) => !this.selected_metrics.map((item) => item.id).includes(m.id))
      )
    },
    saveCheckedMetrics() {
      // let selected_metrics_full = this.current_metrics.filter((m) => this.selected_metrics.filter((m_id) => m_id == m.id).length)
      let selected_metrics_full = this.selected_metrics.map((met) => {
        if (this.includedMetrics.find((m) => m.id == met.id)) {
          return this.includedMetrics.find((m) => m.id == met.id)
        } else {
          return { ...met, value: null }
        }
      })
      let metrics_refs = selected_metrics_full.map((x) => x.reference_name)

      const metrics_obj = {
        page_reference: this.pageReference,
        object_type: this.objectType,
        view_type: this.viewType,
        new_metrics_list: metrics_refs
      }

      if (this.$route.params?.page && !this.insideModal) {
        metrics_obj["layout_page_reference"] = this.$route.params?.page
      }
      if (this.componentReference) {
        metrics_obj["component_reference"] = this.componentReference
      }

      this.setViewMetrics(metrics_obj)

      this.$emit("update:includedMetrics", selected_metrics_full)
      this.$emit("done")
    }
  }
}
</script>
